// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-6b4cebad]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.detail-form[data-v-6b4cebad] {\n  margin-top: 10px;\n  width: 100%;\n  font-size: 14px;\n}\n.detail-form td[data-v-6b4cebad] {\n  padding: 12px 16px;\n}", ""]);
// Exports
module.exports = exports;
